import {defineComponent} from "vue"
import {useAppStore} from "@/stores/app"

export default defineComponent({
  methods: {
    async profile() {
      if(this.$auth.isAdmin()) {
        await this.$router.push(this.$routeTo(this.ROUTES.PROFILE))
      } else {
        if(this.$auth.isCompany()) {
          await this.$router.push(this.$routeTo(this.ROUTES.COMPANY_PROFILE, { id: this.$auth.user?.id }))
        } else if(this.$auth.isApplicant()) {
          await this.$router.push(this.$routeTo(this.ROUTES.WELDER_PROFILE, { id: this.$auth.user?.id }))
        } else {
          const appStore = useAppStore()
          appStore.addError('Please try to logout and log back in')
        }
      }
    }
  },
})
